import { Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";

export function SearchFilter({ onSearch }: any) {
  const handleSearch = (e: any) => {
    const value = e.target.value;
    onSearch(value);
  };

  return (
    <div>
      <Input
        placeholder="Search..."
        prefix={<SearchOutlined />}
        onChange={handleSearch}
        variant="filled"
        size="large"
        style={{ width: 300 }}
      />
    </div>
  );
}
